import React from 'react';
import { Row, Col } from 'antd';

class UnpaidFeeResultLineTextForm extends React.Component {
  render() {
    return (
      <Row>
        <Col span={24}>
          <Row>
            <Col span={10}>
              <label className={'spacing-left'}>{this.props.text}</label>
            </Col>
            <Col span={14}>
              <label>{this.props.value}</label>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className={'fading-line'} />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default UnpaidFeeResultLineTextForm;
